import { supabase } from './supabaseClient';

export async function getUserProfile(userId) {
  const { data, error } = await supabase
    .from('users')
    .select('id, name, email, role, company_name, entreprise, avatar_url, company_logo_url')
    .eq('id', userId)
    .maybeSingle();

  if (error) throw error;
  return data;
}

// Compte pro (users.role = 'professionnel') : on présente l'entreprise (nom et logo) plutôt que la personne.
export function profileIdentity(profile, fallbackEmail = '') {
  const p = profile || {};
  const isPro = p.role === 'professionnel';
  const company = p.company_name || p.entreprise;
  return {
    isPro,
    displayName: (isPro && company) || p.name || fallbackEmail || 'Mon compte',
    imageUrl: (isPro && p.company_logo_url) || p.avatar_url || null,
    email: p.email || fallbackEmail,
    roleLabel: { professionnel: 'Compte pro', particulier: 'Particulier', invite: 'Invité' }[p.role] || '',
  };
}
